module.exports = __webpack_public_path__ + "static/003-017bd83632b85fcee000727b9a770fbf.png";